import { Component, OnDestroy } from "@angular/core";
import { StatusRequest } from "src/app/models/requests";
import { CreateColumn, TableColumn } from "src/app/models/tableColumn";
import { RequestStatusService } from "../requeststatus.service";
import { Subscription } from "rxjs";
import { DataTypeEnum } from "src/app/constants/data-type.enum";
import { ClearancelevelEnum } from "src/app/constants/clearance-levels.enum";
import { AuthenticationService } from "src/app/services/authentication.service";

@Component({
  selector: 'app-request-status-info',
  templateUrl: './request-status-info.component.html'
})
export class RequeststatusInfoComponent implements OnDestroy {
  public request: StatusRequest = {} as StatusRequest;
  public columnsToDisplay: TableColumn[] = [
    CreateColumn<StatusRequest>("status", 'Status', DataTypeEnum.Status, 2, true),
    CreateColumn<StatusRequest>("dossierType", 'Type', DataTypeEnum.RequestType, 2, true),
    CreateColumn<StatusRequest>("ownerFullName", 'Owner', DataTypeEnum.General, 2, true),
    CreateColumn<StatusRequest>("id", 'Id', DataTypeEnum.Guid, 2, true),
    CreateColumn<StatusRequest>("reservedCredits", 'Credits', DataTypeEnum.General, 4, true),
  ];

  private requestSubscription!: Subscription;

  constructor(
    private requestStatusService: RequestStatusService,
    private authenticationService: AuthenticationService
  ) {
    this.requestSubscription = this.requestStatusService.selectedRequest$.subscribe(request => {
      if (Object.keys(request).length === 0) {
        return;
      }
      this.request = request;

      // if we have a request, validate whether some columns need to be shown
      let clearanceLevelColumn = CreateColumn<StatusRequest>("clearancelevel", 'Clearancelevel', DataTypeEnum.General, 4, false);
      let workgroupNameColumn = CreateColumn<StatusRequest>("workgroupName", 'Workgroup', DataTypeEnum.General, 4, true);
      if (this.request.workgroup) {

        // do we have a workgroup
        let currentWorkgroupForRequest = this.authenticationService.workgroups.find(workgroup => workgroup.Guid === this.request.workgroup);

        // verify whether clearance level should be shown
        let indexOfClearanceLevelColumn = this.columnsToDisplay.findIndex(s => s.columnName === clearanceLevelColumn.columnName);
        if (currentWorkgroupForRequest && this.request.clearancelevel === ClearancelevelEnum.One && currentWorkgroupForRequest.Clearancelevel === ClearancelevelEnum.One) {
          // should NOT be added, verify if it was and remove
          if (indexOfClearanceLevelColumn > -1) this.columnsToDisplay.splice(indexOfClearanceLevelColumn, 1);
        } else {
          // should be added, verify if needed and add
          if (indexOfClearanceLevelColumn < 0) this.columnsToDisplay.push(clearanceLevelColumn);
        }


        let workgroupNameIndex = this.columnsToDisplay.findIndex(s => s.columnName === workgroupNameColumn.columnName);
        if (workgroupNameIndex < 0) this.columnsToDisplay.push(workgroupNameColumn);
      } else {
        // no workgroup, verify if columns exist and remove both:
        let workgroupNameIndex = this.columnsToDisplay.findIndex(s => s.columnName === workgroupNameColumn.columnName);
        if (workgroupNameIndex > -1) this.columnsToDisplay.splice(workgroupNameIndex, 1);
        let clearancelevelIndex = this.columnsToDisplay.findIndex(s => s.columnName === clearanceLevelColumn.columnName);
        if (clearancelevelIndex > -1) this.columnsToDisplay.splice(clearancelevelIndex, 1);
      }


      // verify whether Expire Deadline should be shown or removed
      let showExpireDeadline = this.request.expireDeadline != null && this.request.expireDeadline != undefined;
      let expireDeadlineColumn = CreateColumn<StatusRequest>("expireDeadline", 'PurgeDeadline', DataTypeEnum.DateTime, 4, false);
      let expireDeadlineIndex = this.columnsToDisplay.findIndex(s => s.columnName === expireDeadlineColumn.columnName);
      // SHOW, and not yet added
      if (showExpireDeadline && expireDeadlineIndex < 0) {
        this.columnsToDisplay.push(expireDeadlineColumn);
      }
      // HIDE but was added
      if (!showExpireDeadline && expireDeadlineIndex >= 0) {
        this.columnsToDisplay.splice(expireDeadlineIndex, 1);
      }

      // verify whether delete Deadline should be shown or removed
      let showDeleteDeadline = this.request.deleteDeadline != null && this.request.deleteDeadline != undefined;
      let deleteDeadlineColumn = CreateColumn<StatusRequest>("deleteDeadline", 'DeleteDeadline', DataTypeEnum.DateTime, 4, false);
      let deleteDeadlineIndex = this.columnsToDisplay.findIndex(s => s.columnName === deleteDeadlineColumn.columnName);
      // SHOW, and not yet added
      if (showDeleteDeadline && deleteDeadlineIndex < 0) {
        this.columnsToDisplay.push(deleteDeadlineColumn);
      }
      // HIDE but was added
      if (!showDeleteDeadline && deleteDeadlineIndex >= 0) {
        this.columnsToDisplay.splice(deleteDeadlineIndex, 1);
      }
    });
  }



  ngOnDestroy(): void {
    this.requestSubscription.unsubscribe();
  }
}
